import React from 'reactn';

export const UnidadBase = (props) => {
    return <span className={props.claseExtra}> {props.valor || props?.[props?.column?.field]}<span className={"label-unidad"}>{props.unidad}</span></span>
}